"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.writeFiles = exports.updateSettings = exports.updateModifiedTimes = exports.unsetLoadingState = exports.unsetHasSavedChanges = exports.toggleRerenderFlag = exports.setSettings = exports.setPath = exports.setLoadingState = exports.setLoadedFiles = exports.setJustPath = exports.setHasSavedChanges = exports.setHasInitialized = exports.setBasePath = exports.saveSettings = exports.removeNewLocal = exports.removeLocal = exports.loadSettings = exports.loadFiles = exports.initializeFiles = exports.initialState = exports["default"] = exports.copyHash = exports.changeLocalFiles = void 0;
var _reduxActions = require("redux-actions");
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _update2 = _interopRequireDefault(require("lodash/update"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _getObjectHash = _interopRequireDefault(require("../helpers/getObjectHash"));
var _forms = _interopRequireDefault(require("../pages/Gui/forms"));
var _appDefsObject = require("./appDefsObject.js");
var _handleActions;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var Boilerplate = window.cccisd.boilerplate;

// Initial state
var initialState = exports.initialState = {
  forms: _forms["default"].map(function (form) {
    return (0, _pick2["default"])(form, ['path', 'breadcrumb']);
  }),
  basePath: '',
  path: '',
  files: {},
  hasInitialized: false,
  hasSavedChanges: false,
  loading: true,
  rerenderFlag: false,
  saveSettingsHash: '',
  settings: {},
  settingsHash: ''
};

// Actions
var SET_LOADING_STATE = 'appdefs/gui/SET_LOADING_STATE';
var UNSET_LOADING_STATE = 'appdefs/gui/UNSET_LOADING_STATE';
var SET_HAS_INITIALIZED = 'appdefs/gui/SET_HAS_INITIALIZED';
var SET_SETTINGS = 'appdefs/gui/SET_SETTINGS';
var UPDATE_SETTINGS = 'appdefs/gui/UPDATE_SETTINGS';
var SET_HAS_SAVED_CHANGES = 'appdefs/gui/SET_HAS_SAVED_CHANGES';
var UNSET_HAS_SAVED_CHANGES = 'appdefs/gui/UNSET_HAS_SAVED_CHANGES';
var SET_BASE_PATH = 'appdefs/gui/SET_BASE_PATH';
var SET_PATH = 'appdefs/gui/SET_PATH';
var COPY_HASH = 'appdefs/gui/COPY_HASH';
var CHANGE_LOCAL_FILES = 'appdefs/gui/CHANGE_LOCAL_FILES';
var REMOVE_LOCAL = 'appdefs/gui/REMOVE_LOCAL';
var REMOVE_NEW_LOCAL = 'appdefs/gui/REMOVE_NEW_LOCAL';
var SET_LOADED_FILES = 'appdefs/gui/SET_LOADED_FILES';
var UPDATE_MODIFIED_TIMES = 'appdefs/gui/UPDATE_MODIFIED_TIMES';
var TOGGLE_RERENDER_FLAG = 'appdefs/gui/TOGGLE_RERENDER_FLAG';

// Action Creators
var setLoadingState = exports.setLoadingState = (0, _reduxActions.createAction)(SET_LOADING_STATE);
var unsetLoadingState = exports.unsetLoadingState = (0, _reduxActions.createAction)(UNSET_LOADING_STATE);
var setHasInitialized = exports.setHasInitialized = (0, _reduxActions.createAction)(SET_HAS_INITIALIZED);
var setSettings = exports.setSettings = (0, _reduxActions.createAction)(SET_SETTINGS);
var updateSettings = exports.updateSettings = (0, _reduxActions.createAction)(UPDATE_SETTINGS);
var setHasSavedChanges = exports.setHasSavedChanges = (0, _reduxActions.createAction)(SET_HAS_SAVED_CHANGES);
var unsetHasSavedChanges = exports.unsetHasSavedChanges = (0, _reduxActions.createAction)(UNSET_HAS_SAVED_CHANGES);
var setBasePath = exports.setBasePath = (0, _reduxActions.createAction)(SET_BASE_PATH);
var setJustPath = exports.setJustPath = (0, _reduxActions.createAction)(SET_PATH);
var copyHash = exports.copyHash = (0, _reduxActions.createAction)(COPY_HASH);
var changeLocalFiles = exports.changeLocalFiles = (0, _reduxActions.createAction)(CHANGE_LOCAL_FILES);
var removeLocal = exports.removeLocal = (0, _reduxActions.createAction)(REMOVE_LOCAL);
var removeNewLocal = exports.removeNewLocal = (0, _reduxActions.createAction)(REMOVE_NEW_LOCAL);
var setLoadedFiles = exports.setLoadedFiles = (0, _reduxActions.createAction)(SET_LOADED_FILES);
var updateModifiedTimes = exports.updateModifiedTimes = (0, _reduxActions.createAction)(UPDATE_MODIFIED_TIMES);
var toggleRerenderFlag = exports.toggleRerenderFlag = (0, _reduxActions.createAction)(TOGGLE_RERENDER_FLAG);
var SETTINGS_MAP = {
  app: 'app.json',
  application: 'application.json',
  assignments: 'assignments.json',
  bulkUpload: 'bulkUpload.json',
  boilerplate: 'boilerplate.json',
  flow: 'flow.json',
  helpCenters: 'helpCenters.json',
  metrics: 'metrics.json',
  pawnData: 'pawnData.json',
  reports: 'reports.json',
  tables: 'tables.json',
  resourceCenters: 'resourceCenters.json',
  reportCenters: 'reportCenters.json',
  routes: 'routes.json',
  sessions: 'sessions.json',
  customTables: 'customTables.json'
};

/* ***************************************************** */
/* ****************** CUSTOM ACTIONS ******************* */
/* ***************************************************** */

var initializeFiles = exports.initializeFiles = function initializeFiles(_ref) {
  var filenames = _ref.filenames,
    projectId = _ref.projectId;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch, getState) {
      var localState, initializedFiles, alreadyLoadedRequestedFilenames;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            localState = getState().appdefs.gui;
            initializedFiles = Object.keys(localState.files);
            alreadyLoadedRequestedFilenames = Array.isArray(filenames) && filenames.every(function (f) {
              return initializedFiles.includes(f);
            });
            if (!(!localState.hasInitialized && !alreadyLoadedRequestedFilenames)) {
              _context.next = 7;
              break;
            }
            _context.next = 6;
            return dispatch(loadFiles({
              filenames: filenames,
              projectId: projectId
            }));
          case 6:
            // Only considered initialized if all files are loaded (i.e., no
            // filenames specified)
            if (!filenames) {
              dispatch(setHasInitialized());
            }
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var setPath = exports.setPath = function setPath(_ref3) {
  var path = _ref3.path,
    setPathToUrl = _ref3.setPathToUrl;
  return function (dispatch, getState) {
    dispatch(setJustPath(path));
    if (setPathToUrl) {
      var state = getState().appdefs.gui;
      setPathToUrl(state.path);
    }
  };
};
var loadFiles = exports.loadFiles = function loadFiles(_ref4) {
  var filenames = _ref4.filenames,
    projectId = _ref4.projectId;
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState) {
      var qsfiles, params, response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dispatch(setLoadingState());
            qsfiles = Array.isArray(filenames) ? filenames.join(',') : '';
            params = {};
            if (qsfiles) {
              params.filenames = qsfiles;
            }
            if (projectId) {
              params.projectId = projectId;
            }
            _context2.next = 7;
            return (0, _cccisdAxios["default"])({
              method: 'get',
              url: Boilerplate.route('app.get.bulkConfig'),
              params: params
            });
          case 7:
            response = _context2.sent;
            if (!(response.data.status === 'success')) {
              _context2.next = 11;
              break;
            }
            _context2.next = 11;
            return dispatch(setLoadedFiles(response.data.data));
          case 11:
            dispatch(unsetLoadingState());
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var loadSettings = exports.loadSettings = function loadSettings() {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch, getState) {
      var files, settings, settingsKeys, i, key, filename;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            files = getState().appdefs.gui.files;
            settings = {};
            settingsKeys = Object.keys(SETTINGS_MAP);
            i = 0;
          case 4:
            if (!(i < settingsKeys.length)) {
              _context3.next = 14;
              break;
            }
            key = settingsKeys[i];
            filename = SETTINGS_MAP[key];
            if (!files[filename]) {
              _context3.next = 11;
              break;
            }
            _context3.next = 10;
            return JSON.parse(files[filename].contents);
          case 10:
            settings[key] = _context3.sent;
          case 11:
            i++;
            _context3.next = 4;
            break;
          case 14:
            _context3.next = 16;
            return dispatch(setSettings(settings));
          case 16:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var saveSettings = exports.saveSettings = function saveSettings() {
  var overwriteAllModified = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var projectId = arguments.length > 1 ? arguments[1] : undefined;
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dispatch, getState) {
      var settings, files, settingsFiles, response;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            settings = getState().appdefs.gui.settings;
            files = getState().appdefs.gui.files;
            settingsFiles = [];
            Object.keys(settings).forEach(function (key) {
              if (settings[key] !== undefined) {
                var contents = JSON.stringify(settings[key], null, 4);
                var filename = SETTINGS_MAP[key];
                var file = files[filename] ? (0, _cloneDeep2["default"])(files[filename]) : null;
                if (file) {
                  // Update the existing file
                  file.contents = contents;
                  settingsFiles.push(file);
                } else {
                  // This file didn't exist before; we will need to create it
                  settingsFiles.push({
                    path: filename,
                    contents: contents
                  });
                }
              }
            });
            if (settingsFiles.length) {
              _context4.next = 6;
              break;
            }
            return _context4.abrupt("return", false);
          case 6:
            _context4.next = 8;
            return dispatch(changeLocalFiles(settingsFiles));
          case 8:
            _context4.next = 10;
            return dispatch(writeFiles(settingsFiles.map(function (f) {
              return f.filename;
            }), overwriteAllModified, projectId));
          case 10:
            response = _context4.sent;
            if (response.status === 200 && response.data.status === 'success') {
              dispatch(setHasSavedChanges());
              dispatch(copyHash());
            }
            return _context4.abrupt("return", response);
          case 13:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x7, _x8) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var writeFiles = exports.writeFiles = function writeFiles(filenames) {
  var overwriteAllModified = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var projectId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dispatch, getState) {
      var existingFiles, files, response;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            existingFiles = getState().appdefs.gui.files;
            files = [];
            if (!(!filenames || filenames.length === 0)) {
              _context5.next = 6;
              break;
            }
            files = Object.values(existingFiles);
            _context5.next = 10;
            break;
          case 6:
            filenames = _filenamesThatMatch(filenames, Object.keys(existingFiles));
            if (filenames.length) {
              _context5.next = 9;
              break;
            }
            return _context5.abrupt("return", false);
          case 9:
            filenames.forEach(function (filename) {
              files.push(existingFiles[filename]);
            });
          case 10:
            _context5.next = 12;
            return _cccisdAxios["default"].post(Boilerplate.route('app.set.bulkConfig'), {
              data: {
                files: files,
                overwriteAllModified: overwriteAllModified,
                projectId: projectId
              }
            });
          case 12:
            response = _context5.sent;
            if (response.data && response.data.status === 'success') {
              dispatch(updateModifiedTimes(response.data.data.files));
              dispatch((0, _appDefsObject.setAppDefsObject)(response.data.data.appDefsObject));
            }
            return _context5.abrupt("return", response);
          case 15:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x9, _x10) {
      return _ref8.apply(this, arguments);
    };
  }();
};

/* ***************************************************** */
/* ********************** HELPERS ********************** */
/* ***************************************************** */

var _escapeRegExp = function _escapeRegExp(s) {
  s = s.replace(/[-/\\^$+?.()|[\]{}]/g, '\\$&');
  return s.replace(new RegExp('\\*', 'g'), '.*');
};
var _filenamesThatMatch = function _filenamesThatMatch(filenames, existingFilenames) {
  var filenamesThatMatch = [];
  filenames.forEach(function (filename) {
    if (filename) {
      var filenameRegexReady = _escapeRegExp(filename);
      var matching = existingFilenames.filter(function (efilename) {
        return efilename.match("^".concat(filenameRegexReady, "$"));
      });
      filenamesThatMatch = filenamesThatMatch.concat(matching);
    }
  });
  return _toConsumableArray(new Set(filenamesThatMatch));
};

// Reducers
var _default = exports["default"] = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, SET_LOADING_STATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: true
  });
}), UNSET_LOADING_STATE, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    loading: false
  });
}), CHANGE_LOCAL_FILES, function (state, action) {
  var updatedFiles = Object.assign({}, state.files);
  if (action.payload && action.payload.length) {
    action.payload.forEach(function (file) {
      file.hasChanged = true;
      updatedFiles[file.filename] = file;
    });
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    files: updatedFiles
  });
}), REMOVE_LOCAL, function (state, action) {
  var filesToCheck = action.payload || false;
  if (filesToCheck) {
    filesToCheck = Array.isArray(filesToCheck) ? filesToCheck : [filesToCheck];
  }
  var updatedFiles = Object.assign({}, state.files);
  if (filesToCheck.length) {
    filesToCheck = _filenamesThatMatch(filesToCheck, Object.keys(updatedFiles));
    filesToCheck.forEach(function (filename) {
      delete updatedFiles[filename];
    });
  } else {
    updatedFiles = {};
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    files: updatedFiles
  });
}), REMOVE_NEW_LOCAL, function (state, action) {
  var filesToCheck = action.payload || false;
  if (filesToCheck) {
    filesToCheck = Array.isArray(filesToCheck) ? filesToCheck : [filesToCheck];
  }
  var updatedFiles = Object.assign({}, state.files);
  if (filesToCheck.length) {
    filesToCheck = _filenamesThatMatch(filesToCheck, Object.keys(updatedFiles));
    filesToCheck.forEach(function (filename) {
      if (!updatedFiles[filename].modified) {
        delete updatedFiles[filename];
      }
    });
  } else {
    Object.keys(updatedFiles).forEach(function (filename) {
      if (!updatedFiles[filename].modified) {
        delete updatedFiles[filename];
      }
    });
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    files: updatedFiles
  });
}), SET_LOADED_FILES, function (state, action) {
  var updatedFiles = Object.assign({}, state.files);
  if (Array.isArray(action.payload) && action.payload.length) {
    action.payload.forEach(function (file) {
      updatedFiles[file.filename] = file;
    });
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    files: updatedFiles
  });
}), SET_HAS_INITIALIZED, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    hasInitialized: true
  });
}), SET_SETTINGS, function (state, action) {
  var hash = (0, _getObjectHash["default"])(action.payload);
  return _objectSpread(_objectSpread({}, state), {}, {
    settings: action.payload,
    settingsHash: hash,
    savedSettingsHash: hash
  });
}), UPDATE_SETTINGS, function (state, action) {
  var _action$payload = action.payload,
    path = _action$payload.path,
    settings = _action$payload.settings;
  var newSettings = (0, _cloneDeep2["default"])(state.settings);
  if (path === '') {
    newSettings = _objectSpread(_objectSpread({}, newSettings), settings);
  } else {
    (0, _update2["default"])(newSettings, path, function (obj) {
      if ((0, _isArray2["default"])(settings)) {
        return settings;
      }
      return _objectSpread(_objectSpread({}, obj), settings);
    });
  }
  var hash = (0, _getObjectHash["default"])(newSettings);
  return _objectSpread(_objectSpread({}, state), {}, {
    settings: newSettings,
    settingsHash: hash
  });
}), SET_HAS_SAVED_CHANGES, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    hasSavedChanges: true
  });
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, UNSET_HAS_SAVED_CHANGES, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    hasSavedChanges: false
  });
}), SET_BASE_PATH, function (state, action) {
  if (action.payload === state.basePath) {
    return state;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    basePath: action.payload
  });
}), SET_PATH, function (state, action) {
  var path = action.payload;
  var currentPath = state.path;

  // absolute path starts with '/'
  if (/^\//.test(path)) {
    path = path.substring(1);
  } else if (currentPath !== '') {
    if (/^\[/.test(path)) {
      path = currentPath + path;
    } else {
      path = currentPath + '.' + path;
    }
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    path: path
  });
}), COPY_HASH, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    savedSettingsHash: state.settingsHash
  });
}), UPDATE_MODIFIED_TIMES, function (state, action) {
  if (!action.payload) {
    return state;
  }
  var updatedFiles = Object.assign({}, state.files);
  if (action.payload.length) {
    action.payload.forEach(function (file) {
      updatedFiles[file.filename].modified = file.modified;
      updatedFiles[file.filename].hasChanged = false;
    });
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    files: updatedFiles
  });
}), TOGGLE_RERENDER_FLAG, function (state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    rerenderFlag: !state.rerenderFlag
  });
})), initialState);